package com.kinoshazam.screens.decide

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import qrcode.raw.QRCodeProcessor

@Composable
fun InviteQrCode(
    data: String,
    modifier: Modifier = Modifier,
    darkColor: Color = Color.Black,
    lightColor: Color = Color.White,
) {
    val modules = remember(data) {
        QRCodeProcessor(data).encode().map { row ->
            row.map { it.dark }
        }
    }
    Box(
        modifier = modifier
            .clip(RoundedCornerShape(12.dp))
            .background(lightColor)
            .padding(12.dp),
    ) {
        Canvas(modifier = Modifier.fillMaxSize()) {
            val count = modules.size.coerceAtLeast(1)
            val cell = size.minDimension / count
            val originX = (size.width - cell * count) / 2f
            val originY = (size.height - cell * count) / 2f
            modules.forEachIndexed { row, cols ->
                cols.forEachIndexed { col, dark ->
                    if (dark) {
                        drawRect(
                            color = darkColor,
                            topLeft = Offset(originX + col * cell, originY + row * cell),
                            size = Size(cell, cell),
                        )
                    }
                }
            }
        }
    }
}
